
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.5 12a8.476 8.476 0 01-.604 3.152v2.466c0 .199-.015.39-.043.574A9.957 9.957 0 0022 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.369 2.801 8.083 6.706 9.445l.067.025.048.015.08.026c.078.025.157.05.235.073a6.548 6.548 0 001.767.304c.43.013.834.003 1.23-.096.412-.102.77-.287 1.137-.56.924-.689 1.282-1.874 1.116-3.037-.124-.872-.523-1.573-1.134-2.299-.438-.52-1.016-1.089-1.722-1.764a3.053 3.053 0 00-.506-3.648L9.772 9.232l-.65.649-1.597-1.598a.75.75 0 10-1.06 1.06l1.552 1.553-.87.87-1.552-1.553a.75.75 0 10-1.06 1.06l1.597 1.598-.675.676 1.252 1.252a3.052 3.052 0 003.79.422c.696.666 1.217 1.179 1.605 1.64.506.602.726 1.049.797 1.546.108.756-.144 1.337-.527 1.622-.244.181-.423.263-.602.307-.193.049-.432.064-.824.052-.622-.019-1.072-.143-1.53-.287A8.5 8.5 0 1120.5 12zm-1.604-1.81l-5.692-5.836-1.074 1.048 2.39 2.45v4.734l2.876 2.877v2.155c0 .374-.16.715-.47 1.053-.318.346-.754.646-1.212.913a5.74 5.74 0 01-.411.217 3.887 3.887 0 01-1.113 1.962 8.191 8.191 0 002.28-.883c.5-.292 1.091-.683 1.561-1.195.478-.521.865-1.208.865-2.067v-7.429zm-2.877 1.775V9.389l1.377 1.41v2.543l-1.377-1.377zm-6.247-.612l-2.194 2.194.192.192a1.551 1.551 0 002.194-2.194l-.192-.192z","fill":"currentColor"}})])
          )
        }
      }
    